export default (theme) => ({
    root: {
        alignItems: 'center',
        backgroundColor: theme.colors.semantic.negative100,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.colors.transparent,
        borderRadius: 6,
        display: 'flex',
        gap: 8,
        padding: 8,
        width: '100%',
        position: 'relative',
    },
    message: {
        flex: 1,
        maxHeight: 100,
        overflow: 'auto',
        '& *': {
            lineHeight: 1.4,
        },
        '& strong': {
            fontWeight: 500,
        },
    },
    dismissible: {
        '&:hover': {
            borderColor: theme.colors.grey[100],
            '& $dismissButton': {
                opacity: 1,
            },
        },
    },
    dismissButton: {
        cursor: 'pointer',
        flexShrink: 0,
        opacity: 0,
        transition: 'opacity 0.2s ease',
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        position: 'absolute',
        right: -8,
        top: -8,
        border: `1px solid ${theme.colors.grey[100]}`,
        backgroundColor: theme.colors.primary.white,
        boxShadow: '2px -1px 6px 0px #0000001A',
    },
});
